import React, { memo } from 'react';

import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';

import * as ST from './styled';


interface ICopyrightText {
    company: string,
    link: string,
}

const CopyrightText = memo(
    ({ company, link }: ICopyrightText): JSX.Element => {
        return (<ST.CopyrightText>{company} осуществляет обработку персональных и иных пользовательских данных
            в соответствии с{NBSP}
            <ST.CopyrightLink href={link}>
                Политикой в отношении обработки персональных данных
            </ST.CopyrightLink>.
        </ST.CopyrightText>);
    },
);

CopyrightText.displayName = 'CopyrightText';

export default CopyrightText;
